import './styles.scss';

import { ReactElement } from 'react';
import SkyhopPdfFooterSection from '@/features/PdfLayout/components/SkyhopPdfFooter/SkyhopPdfFooterSection';
import SkyhopPdfFooterSectionHeader from '@/features/PdfLayout/components/SkyhopPdfFooter/SkyhopPdfFooterSectionHeader';
import SkyhopPdfFooterSectionItem from '@/features/PdfLayout/components/SkyhopPdfFooter/SkyhopPdfFooterSectionItem';
import { getClasses } from '@/utils';

export type SkyhopPdfFooterProps = React.ComponentProps<'div'> & { title?: string };

const SkyhopPdfFooter = ({ children, title, ...props }: SkyhopPdfFooterProps): ReactElement => (
  <div {...props} className={getClasses('SkyhopPdfFooter', props.className)}>
    {title && (
      <div className="SkyhopPdfFooter-Title">
        <span>{title}</span>
      </div>
    )}
    <div className="SkyhopPdfFooter-Content">{children}</div>
  </div>
);

SkyhopPdfFooter.Section = SkyhopPdfFooterSection;
SkyhopPdfFooter.SectionHeader = SkyhopPdfFooterSectionHeader;
SkyhopPdfFooter.Item = SkyhopPdfFooterSectionItem;

export default SkyhopPdfFooter;
